import { render, staticRenderFns } from "./SoTruongList.vue?vue&type=template&id=144f8cdb&"
import script from "./SoTruongList.vue?vue&type=script&lang=js&"
export * from "./SoTruongList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports